import React from 'react';
import { UncontrolledTooltip } from 'reactstrap';
import { useTranslation } from "react-i18next";
import './statementUnavailableTooltip.css';

const StatementUnavailbleTooltip = ({id}) => {
  const rowId = "statement-row-" + id.toString();
  const { t } = useTranslation();
  return (
    <div>
        <i className="tooltip-icon mdi mdi-24px mdi-help-circle text-center" style={{color: "#000a60"}} id={rowId} aria-hidden="true"></i>
        <UncontrolledTooltip style={{background: "#000a60"}}  placement="bottom" target={rowId}>
          {t("subuserStatements.view.table.message.statementUnavailable")}
        </UncontrolledTooltip>
    </div>
  );
};

export default StatementUnavailbleTooltip;
